import { render } from "./confirmEmail.vue?vue&type=template&id=1ab5ef00"
import script from "./confirmEmail.vue?vue&type=script&lang=js"
export * from "./confirmEmail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__